import { render } from "./Proveedor_Cliente_Agregar_Orden.vue?vue&type=template&id=fc999150"
import script from "./Proveedor_Cliente_Agregar_Orden.vue?vue&type=script&lang=js"
export * from "./Proveedor_Cliente_Agregar_Orden.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__